import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISProgressBarComponent } from './is-progress-bar.component';
import { MatTooltipModule } from '@angular/material/tooltip';

const materialModules = [
    MatTooltipModule
];

@NgModule({
    declarations: [ISProgressBarComponent],
    imports: [
        CommonModule,
        ...materialModules    
    ],
    exports: [ISProgressBarComponent],
    providers: [],
})
export class ISProgressBarModule {}